<template>
  <div class="role-auth-document" v-loading="permLoading">
    <div  class="role-auth-content"  v-if="!!node">
      <div class="role-auth-title">角色权限</div>
      <div class="role-right-bottom">
        <template>
          <div v-if="node.$topLevel" class="role-rigth-title">请设置<b style="color:#3873fe;">{{ node.roleName }}</b>分类下角色的权限</div>
          <div v-else class="role-rigth-title">
            <template v-if="isTableDataEmpty">
              新角色暂未同步角色权限信息
            </template>
            <template v-else>
              请设置<b>{{ node.roleName }}</b>的权限
            </template>
          </div>
        </template>
        <template v-if="node.$topLevel != '1'">
          <div class="role-right-table" v-if="!isTableDataEmpty">
            <rolePermisson :refreshStatus="refreshItemStatus" :tableData="tableData" :roleType="type"></rolePermisson>
            <el-button type="primary" size="small" class="role-right-button" @click="submitUpdate"  :disabled="isDisabled">保存</el-button>
          </div>
          <div v-else class="perm_sync">
            <el-button type="primary" size="small" @click="syncRolePermission">同步当前角色权限</el-button>
          </div>
        </template>
      </div>
    </div>
    <div v-else class="uncheckNode">
        <img :src="require('@/CommonDP/assets/暂无数据.png')" />
        <span style="color:gray;font-weight:300;font-size:14px;">请选择分类/角色节点</span>
    </div>
  </div>
</template>
<script>
import rolePermisson from "@/views/components/rolePermisson"
import permission from "@/xgzdService/docPrivi-service"
import { mapState } from "vuex";
import { promiseWrapper } from '@/utils/wrapper';

export default {
  components:{ rolePermisson },
  data() {
    return {
      filterText: "",
      roleducmentList: [],
      major_png: require('@/CommonDP/assets/settings/major.png'),
      role_png: require('@/CommonDP/assets/settings/systemRole.png'),
      tableData: [],
      initRoleList:[],
      permLoading: false
    };
  },
  props: {
      type: {
          required: true
      },
      node: {
          require: true
      },
      submit: {
          type: Function
      }
  },
  watch: {
      node: {
          handler(val) {
              if (val) {
                  this.getDocumentList()
              }
          },
          deep: true
      },
      type: {
          handler(val) {
              this.getDocumentList()
          }
      }
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      enterpriseId: state => state.enterprise.enterpriseId,
    }),
    // 判断是否与原数据发生变化
    isDisabled() {
      return JSON.stringify(this.initRoleList) === JSON.stringify(this.tableData)
    },
    isTableDataEmpty() {
      return !(Array.isArray(this.tableData) && this.tableData.length > 0)
    }
  },
  methods: {
   
    // 获取对应的权限
    async getDocumentList() {
      if (!this.node) {
        console.warn('[角色权限管理] 您未选中左侧树节点')
        return
      }
      let { $topLevel, roleID, roleName } = this.node
      if ($topLevel) return
      const { prjId } = this.prjInfo
      let params = {
        prjId,
        roleId: roleID,
        folderArea: 1,
        userType: 3
      }
      
      const res = await permission.getPrjRolePermission(params);
      let roleData = res?.data
      if (!roleData) {
        this.tableData = []
        console.warn('[角色权限管理] 角色权限信息数据格式异常')
        return
      }
      roleData.name = roleName
      this.tableData = [roleData].map((item) => {
        if (item.isRead === 2) {
          item.$show = 1;item.$down = 1;
        } else if (item.isRead === 1) {
          item.$show = 1;item.$down = 0;
        } else {
          item.$show = 0;item.$down = 0;
        }

        this.refreshItemStatus(item)
        return item
      })
      this.initRoleList = JSON.parse(JSON.stringify(this.tableData))
    },

    async syncRolePermission() {
      const { roleID:roleId, pid:specId } = this.node
      const { prjId } = this.prjInfo
      const { enterpriseId } = this
      this.permLoading = true
      let res = await promiseWrapper(permission.syncRolePermission({
        roleId,
        specId,
        prjId,
        enterpriseId
      }), '[角色权限管理] 同步当前角色权限')
      this.permLoading = false

      if (res.result == '0') {
        this.$message.success('同步角色权限信息成功')
        this.getDocumentList()
      }
    },
    refreshItemStatus(item) {
      const status = this.getItemsCombine(item)
      status === 2 ? item.indeterminate = true : item.indeterminate = false
      if (status !== 2) item.$selectAll = status
    },
    getItemsCombine(item) {
      const baseKeys = ['$show', '$down', 'folderNew', 'fileDel', 'isPriviSet', 'priviAll']
      const auditKeys = ['fileNew','isPlaceFile']
      const allKeys = this.type === '1' ? baseKeys.concat(auditKeys) : baseKeys
      const sum =   allKeys.map(key => !!item[key] ? 1 : 0).reduce((pre, curr) => pre + curr )
      return sum === 0 ? 0: sum === allKeys.length ? 1 : 2 
    },

    
    async submitUpdate() {
      const { tableData } = this;
      if (!Array.isArray(tableData) && !tableData[0]) return
      let item = tableData[0]
      if (item.$show === 1 && item.$down === 1) item.isRead = 2;
      else if (item.$show === 1 && item.$down === 0) item.isRead = 1;
      else item.isRead = 0;
      let { roleID } = this.node
      let {
        fileDel, fileNew, folderArea = this.type, folderDel, folderNew, isPlaceFile, isPrint,
        isPriviSet, isRead, isSnapshot, isSubmit, priviAll, prjId = this.prjInfo.prjId, roleId =  roleID, userType = 3
      } = item
      let params = {
        fileDel, fileNew, folderArea, folderDel, folderNew, isPlaceFile, isPrint,
        isPriviSet, isRead, isSnapshot, isSubmit, priviAll, prjId, roleId, userType
      }
      if (typeof this.submit === 'function') {
          await this.submit(params)
      }
      this.permLoading = true
      await this.getDocumentList().catch(err => console.error(err.message || err));
      this.permLoading = false
    },
  }
};
</script>
<style lang="scss">
.role-auth-aside{
  .el-tree-node__content {
    line-height: 20px;
    padding: 4px;
  }
}
.role-right-table{
  .el-checkbox{
    margin-right: 20px;
    .el-checkbox__input.is-checked+.el-checkbox__label{
      color: #2E384D !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.perm_sync {
  display: flex;
  padding: 10px 0px;
  box-sizing: border-box;
  align-items: center;

}
.uncheckNode {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;
    > img {
        margin: 10px 0px;
    }
}
.role-auth-document{
  height: 100%;
  width: 100%;
  padding: 0;
  position: relative;
  .role-auth-content {
    position: absolute;
    left: 0px;
    right: 0;
    bottom: 0;
    top: 0;
    .role-auth-title{
      padding: 17px;
      font-size: 16px;
      font-weight: 700;
      line-height: 20px;
    }
    .role-right-bottom{
      padding:0 17px;
      .role-rigth-title{
        color:#58667A;
        font-size: 14px;
        line-height: 18px;
      }
      .role-right-table{
        overflow: auto;
        position: absolute;
        top: 83px;
        bottom: 10px;
        right: 0;
        padding-right: 20px;
        left: 17px;

      }
      .role-right-button{
        float: right;
        margin-top: 10px;
      }
    }
  }
  .empty{
    text-align: center;
    font-size: 36px;
    color: #ddd;
    font-weight: bolder;
    letter-spacing: 5px;
  }
  .textAll{
    width:150px;
    font-size: 16px;
    overflow:hidden;
    white-space:nowrap;
    text-overflow:ellipsis;
  }
}
</style>
